var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333252,
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#ECFDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3333 41.3335C36.3333 38.388 32.7515 36.0002 28.3333 36.0002C23.915 36.0002 20.3333 38.388 20.3333 41.3335M44.3333 29.3335L38.9999 34.6668L36.3333 32.0002M28.3333 32.0002C25.3877 32.0002 22.9999 29.6123 22.9999 26.6668C22.9999 23.7213 25.3877 21.3335 28.3333 21.3335C31.2788 21.3335 33.6666 23.7213 33.6666 26.6668C33.6666 29.6123 31.2788 32.0002 28.3333 32.0002Z",
    stroke: "#027A48",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveEmployees);
export default __webpack_public_path__ + "static/media/Active Employees.c0318c4f0da840f73f4e8dd36fdbc28e.svg";
export { ForwardRef as ReactComponent };